import { useQuery } from '@tanstack/react-query';
import { shareService } from '../services/shareService';
import type { ShareResourceType } from '../types';

export function useSharesForResource(
  resourceType: ShareResourceType,
  resourceId: string | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: ['shares', 'resource', resourceType, resourceId],
    queryFn: () =>
      shareService.listForResource(resourceType, resourceId as string),
    enabled: enabled && !!resourceId,
  });
}
